'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoEyeDisabled = function IoEyeDisabled(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.9 12.3c3.2 2.2 5.9 5.2 8.1 7.9-4 4.2-9.7 10.5-17.5 10.5-2.8 0-5.1-0.6-7.2-1.7l-6 6-1.8-1.8 5.5-5.5c-2.8-2-5.3-4.8-8-7.7 6.1-6.6 11.1-10.7 17.5-10.7 2.7 0 5 0.7 7.2 1.8l6-6.1 1.8 1.8z m-16.4 7.7c0 1.5 0.4 2.8 1.2 4l2.1-2.1c-0.3-0.6-0.4-1.2-0.4-1.9 0-2.3 1.8-4.1 4.1-4.1h0.6c-0.4 0.4-0.6 1-0.6 1.6 0 0.2 0 0.4 0.1 0.6l4-3.9c-1.2-0.8-2.6-1.3-4.1-1.3-3.8 0-7 3.2-7 7.1z m7 7.1c3.8 0 7-3.2 7-7.1 0-1.5-0.4-2.9-1.2-4.1l-3.9 4c0.2 0.1 0.4 0.1 0.6 0.1 0.6 0 1.1-0.2 1.6-0.5v0.5c0 2.3-1.8 4.1-4.1 4.1-0.7 0-1.3-0.1-1.9-0.4l-2.2 2.1c1.2 0.8 2.6 1.3 4.1 1.3z' })
        )
    );
};

exports.default = IoEyeDisabled;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/eye-disabled.js
// module id = 2049
// module chunks = 0